import React from "react";

const Loading = () => {
  return (
    <div className="col-12 text-center" style={{ padding: "250px" }}>
      <span className="fa fa-spinner fa-5x fa-fw text-primary fa-pulse"></span>
    </div>
  );
};

export default Loading;
